// extracted by mini-css-extract-plugin
module.exports = {"layout":"styles_layout___6rn0","layoutContent":"styles_layoutContent__2YhKC"};